<template>
    <div>
        <b-navbar toggleable="lg" class="bg-white nav-header">
            <b-navbar-brand href="/">
                <b-img src="/img/logo_ba_che.png" class="nav-logo-img" alt="Logo" />
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse" />

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                    <b-nav-item
                        v-for="navItem in navItems[selectedView]
                            ? navItems[selectedView].children
                            : CONSTANTS.COMMON_NAV"
                        :key="navItem.url"
                        :to="navItem.url"
                        v-if="checkUserFunction(navItem.permissions)"
                        >{{ navItem[locale] }}</b-nav-item
                    >

                    <div v-if="!!currentUserDetail" class="mx-3 font-20 d-md-down-none">|</div>
                    <b-nav-item-dropdown right v-if="!!currentUserDetail">
                        <template #button-content>
                            <i class="fa fa-user mr-1" aria-hidden="true" id="nav-profile"></i>
                            {{ currentUserDetail ? currentUserDetail.name : '' }}
                            <b-tooltip target="nav-profile" placement="bottom">{{
                                $t('topMenu.userProfile')
                            }}</b-tooltip>
                        </template>

                        <!-- Dropdown -->
                        <b-dropdown-item
                            v-if="!currentUserDetail.verified"
                            @click="openConfirmPhoneModal"
                            class="bg-white"
                        >
                            <i class="fa fa-exclamation-triangle text-danger"></i>
                            Xác thực số điện thoại
                        </b-dropdown-item>
                        <b-dropdown-item @click="openUpdateProfileInfoModal" class="bg-white">
                            <i class="fa fa-user text-primary"></i>
                            {{ $t('topMenu.updateProfile') }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="openChangePassModal" class="bg-white">
                            <i class="fa fa-wrench text-primary"></i>
                            {{ $t('topMenu.changePassword') }}
                        </b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="logout" class="bg-white">
                            <i class="fa fa-sign-out text-primary"></i>
                            {{ $t('topMenu.logout') }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <div v-if="!!currentUserDetail" class="mx-3 font-20 d-md-down-none">|</div>
                    <b-nav-item-dropdown right v-if="!!currentUserDetail">
                        <template #button-content>
                            <i
                                v-if="selectedView"
                                :class="navItems[selectedView].iconClass"
                                class="mr-1"
                                aria-hidden="true"
                                id="view-change"
                            ></i>
                            <b-tooltip target="view-change" placement="bottom">{{
                                $t('topMenu.changeView')
                            }}</b-tooltip>
                        </template>

                        <!-- Dropdown -->
                        <b-dropdown-item
                            @click="changeView(view)"
                            class="bg-white"
                            v-for="view in Object.keys(navItems)"
                            v-if="checkUserFunction(navItems[view].permissions)"
                            :key="view"
                            :active="view === selectedView"
                        >
                            <i
                                :class="navItems[view].iconClass"
                                class="text-dark"
                                aria-hidden="true"
                            ></i>
                            {{ navItems[view].name[locale] }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-button
                        v-if="!currentUserDetail"
                        pill
                        class="btn-login"
                        @click="openLoginForm"
                        >Đăng nhập</b-button
                    >
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <!-- the modal -->
        <!-- Update profile modal -->
        <b-modal
            ref="updateProfileInfo"
            :title="$t('updateProfileModal.title')"
            no-close-on-esc
            no-close-on-backdrop
            :cancel-title="$t('common.cancel')"
            @ok="handleUpdateProfileOk"
        >
            <form @submit.prevent="submitUpdateProfileForm">
                <b-form-group :label="$t('updateProfileModal.fullName')">
                    <b-form-input
                        maxlength="255"
                        v-model="profileInfo.name"
                        :placeholder="$t('updateProfileModal.fullName')"
                        name="fullName"
                        v-validate="'required'"
                        :data-vv-as="$t('updateProfileModal.fullName')"
                    ></b-form-input>
                    <div v-show="errors.has('fullName')" class="validation-message text-danger">
                        {{ errors.first('fullName') }}
                    </div>
                </b-form-group>

                <b-form-group :label="$t('updateProfileModal.phone')">
                    <b-form-input
                        maxlength="255"
                        v-model="profileInfo.phone"
                        :placeholder="$t('updateProfileModal.phone')"
                        name="phone"
                        v-validate="'required'"
                        :data-vv-as="$t('updateProfileModal.phone')"
                    ></b-form-input>
                    <div v-show="errors.has('phone')" class="validation-message text-danger">
                        {{ errors.first('phone') }}
                    </div>
                </b-form-group>
            </form>
        </b-modal>

        <!-- Change password modal -->
        <b-modal
            ref="changePassModal"
            :title="$t('changePassModal.title')"
            no-close-on-esc
            no-close-on-backdrop
            :cancel-title="$t('common.cancel')"
            @ok="handleChangePassOk"
        >
            <form @submit.prevent="submitChangePassForm">
                <b-form-group :label="$t('changePassModal.currentPass')">
                    <b-form-input
                        maxlength="255"
                        v-model.trim="changePassInfo.oldPassword"
                        :placeholder="$t('changePassModal.currentPass')"
                        name="oldPassword"
                        v-validate="'required'"
                        :data-vv-as="$t('changePassModal.currentPass')"
                        type="password"
                        autocomplete="off"
                    ></b-form-input>
                    <div v-show="errors.has('oldPassword')" class="validation-message text-danger">
                        {{ errors.first('oldPassword') }}
                    </div>
                </b-form-group>

                <b-form-group :label="$t('changePassModal.newPass')">
                    <b-form-input
                        maxlength="255"
                        v-model.trim="changePassInfo.newPassword"
                        :placeholder="$t('changePassModal.newPass')"
                        name="newPassword"
                        v-validate="'required'"
                        :data-vv-as="$t('changePassModal.newPass')"
                        type="password"
                        ref="newPassword"
                        autocomplete="off"
                    ></b-form-input>
                    <div v-show="errors.has('newPassword')" class="validation-message text-danger">
                        {{ errors.first('newPassword') }}
                    </div>
                </b-form-group>

                <b-form-group :label="$t('changePassModal.confirmedPass')">
                    <b-form-input
                        maxlength="255"
                        v-model.trim="confirmedPassword"
                        :placeholder="$t('changePassModal.confirmedPass')"
                        name="confirmedPassword"
                        v-validate="'required|confirmed:newPassword'"
                        :data-vv-as="$t('changePassModal.confirmedPass')"
                        type="password"
                        autocomplete="off"
                    ></b-form-input>
                    <div
                        v-show="errors.has('confirmedPassword')"
                        class="validation-message text-danger"
                    >
                        {{ errors.first('confirmedPassword') }}
                    </div>
                </b-form-group>
            </form>
        </b-modal>

        <b-modal
            ref="confirmPhoneModal"
            title="Xác thực số điện thoại"
            no-close-on-esc
            no-close-on-backdrop
            :cancel-title="$t('common.cancel')"
            @ok="handleConfirmPhoneOk"
        >
            <form @submit.prevent="submitConfirmPhoneForm">
                <b-form-group label="Mã xác thực">
                    <b-form-input
                        maxlength="255"
                        v-model="code"
                        placeholder="Mã xác thực"
                        name="code"
                        v-validate="'required'"
                        data-vv-as="Mã xác thực"
                    ></b-form-input>
                    <div v-show="errors.has('code')" class="validation-message text-danger">
                        {{ errors.first('code') }}
                    </div>
                </b-form-group>
            </form>
        </b-modal>

        <!-- Login modal -->
        <b-modal ref="loginModal" hide-footer hide-header>
            <LoginForm @loginSuccess="loginSuccess" />
        </b-modal>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';
import CONSTANTS from '../constants';
import { i18n } from '../main';
import navItems from '@/nav';
import LoginForm from '@/components/LoginForm';

export default {
    components: {
        LoginForm
    },
    mounted: function () {
        this.$nextTick(async function () {
            this.onRouteChange();
        });
    },
    data() {
        return {
            CONSTANTS,
            changePassInfo: {},
            profileInfo: {
                name: '',
                phone: ''
            },
            confirmedPassword: null,
            navItems,
            selectedView: null,
            code: null
        };
    },
    computed: {
        ...mapState({
            currentUserDetail: (state) => _.cloneDeep(_.get(state.auth, 'currentUser.userDetail')),
            currentUser: (state) => _.cloneDeep(state.auth.currentUser)
        }),
        locale() {
            return i18n.locale;
        }
    },
    watch: {
        $route(val) {
            this.onRouteChange();
        }
    },
    methods: {
        ...mapActions({
            getCurrentUserDetail: 'auth/getCurrentUserDetail',
            actionLogout: 'auth/actionLogout',
            actionChangePass: 'auth/actionChangePass',
            updateProfileInfo: 'user/updateUserInfo',
            createAuditByUser: 'user/createAuditByUser',
            updateAuthState: 'auth/updateState',
            requestConfirmPhone: 'user/requestConfirmPhone',
            confirmPhone: 'user/confirmPhone'
        }),
        async logout() {
            await this.createAuditByUser({ content: 'Đăng xuất hệ thống' });
            await this.actionLogout();
            this.selectedView = null;
            this.$router.push('/home');
        },
        openLoginForm() {
            this.$refs.loginModal.show();
        },
        loginSuccess(data) {
            if (data) {
                this.$refs.loginModal.hide();
                this.$router.push('/home');
            }
        },
        // Change password
        openChangePassModal() {
            // Reset form
            this.changePassInfo = {};
            this.confirmedPassword = null;

            this.$refs.changePassModal.show();
        },

        handleChangePassOk(modal) {
            // Prevent modal from closing
            modal.preventDefault();
            // Trigger submit handler
            this.submitChangePassForm();
        },
        submitChangePassForm: function () {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.actionChangePass(this.changePassInfo).then(() => {
                        this.$toaster.success(this.$t('changePassModal.changePassSuccessMsg'));
                        this.createAuditByUser({ content: 'Đổi mật khẩu' });
                        this.$refs.changePassModal.hide();
                    });
                }
            });
        },
        // confirm phone
        async openConfirmPhoneModal() {
            this.code = '';
            this.$refs.confirmPhoneModal.show();
            await this.requestConfirmPhone();
            this.$toaster.success('Mã xác thực đã được gửi đến số điện thoại của bạn');
        },
        handleConfirmPhoneOk(modal) {
            // Prevent modal from closing
            modal.preventDefault();
            // Trigger submit handler
            this.submitConfirmPhoneForm();
        },
        submitConfirmPhoneForm: function () {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.confirmPhone({ code: this.code }).then(() => {
                        this.$toaster.success('Xác thực thành công');
                        this.createAuditByUser({ content: 'Xác thực số điện thoại' });
                        this.getCurrentUserDetail();
                        this.$refs.confirmPhoneModal.hide();
                    });
                }
            });
        },

        // Update Profile
        openUpdateProfileInfoModal() {
            // Reset form
            this.profileInfo = { ...this.currentUserDetail };
            this.$refs.updateProfileInfo.show();
        },
        handleUpdateProfileOk(modal) {
            // Prevent modal from closing
            modal.preventDefault();
            // Trigger submit handler
            this.submitUpdateProfileForm();
        },
        submitUpdateProfileForm: function () {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.updateProfileInfo(this.profileInfo).then(() => {
                        this.$refs.updateProfileInfo.hide();
                        this.createAuditByUser({ content: 'Cập nhật thông tin cá nhân' });
                        this.$toaster.success(
                            this.$t('updateProfileModal.updateProfileSuccessMsg')
                        );
                        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
                        currentUser.userDetail = { ...this.profileInfo };
                        localStorage.setItem('currentUser', JSON.stringify(currentUser));
                        this.getCurrentUserDetail();
                    });
                }
            });
        },
        checkUserFunction(functionList) {
            const userFunctions = _.get(this.currentUserDetail, 'functions');
            let hasPermission = false;
            if (functionList && userFunctions) {
                functionList.forEach((functionName) => {
                    hasPermission = hasPermission || userFunctions.indexOf(functionName) > -1;
                });
                return hasPermission;
            }
            return true;
        },
        changeView(view) {
            this.selectedView = view;
            this.$router.push(`/home?view=${view}`);
            this.updateAuthState({
                stateName: 'currentUser',
                value: { ...this.currentUser, selectedView: view }
            });
        },
        onRouteChange() {
            Object.keys(navItems).forEach((view) => {
                // TODO: find better way to check 2 routes matching
                const index = navItems[view].children.findIndex(
                    (navItem) => this.$route.path.indexOf(navItem.url) > -1
                );
                if (index > -1) {
                    this.selectedView = view;
                    this.updateAuthState({
                        stateName: 'currentUser',
                        value: { ...this.currentUser, selectedView: view }
                    });
                    return;
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.btn-login {
    background: lightseagreen;
    color: white;
    border-color: lightseagreen;
    margin-right: 1rem !important;
    margin-left: 1rem !important;
}
.nav-header {
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);

    .navbar-nav .nav-item .nav-link {
        color: #000;
        text-decoration: none;
        font-weight: 700;
        text-transform: uppercase;
        padding: 15px;
    }
}

@media screen and (min-width: 1024px) {
    .nav-header {
        height: 70px;

        .navbar-nav {
            align-items: center;
        }
        .nav-logo-img {
            height: 70px;
        }
    }
}

@media screen and (max-width: 768px) {
    .nav-header {
        .navbar-brand {
            height: 50px;
            .nav-logo-img {
                height: 50px;
            }
        }
        .navbar-nav {
            align-items: center;
        }
    }
}
</style>
